import logoutService from '../services/LogoutService';

export const useSignOut = (onDone) => () => {
  onDone();
  logoutService.logoutByUser();
};

export default useSignOut;
